module.exports = __webpack_public_path__ + "img/tipologie_smartbook.215f27b6.png";